module.exports = __webpack_public_path__ + "fonts/AmplitudeTF-Bold_1_b43e5c70.038928fa.woff";